import React from 'react';
import MaskedTextField from 'core/components/MaskedTextField';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';

const amountBlock = Object.freeze({
  mask: Number,
  thousandsSeparator: ',',
  scale: 2,
  normalizeZeros: true,
  padFractionalZeros: false,
  radix: '.',
  placeholderChar: '0',
});

const mask = Object.freeze([{
  mask: '$amount',
  lazy: false,
  overwrite: true,
  blocks: { amount: amountBlock },
}]);

export default function CurrencyTextField({
  value,
  onChange,
}: FieldComponentProps) {
  return (
    <MaskedTextField
      unmask
      mask={[{
        ...mask[0],
        blocks: {
          amount: {
            ...amountBlock,
            min: 0,
          },
        },
      }]}
      defaultValue="0"
      autoFocus
      fullWidth
      value={value?.value ?? ''}
      onAccept={(data: string) => {
        onChange?.({ ...value, value: data });
      }}
    />
  );
}
